import { schema } from '@edgevanta/db/drizzle/client';
import { createInsertSchema, createSelectSchema } from 'drizzle-zod';
import { z } from 'zod/v4';

export const selectBidItemSchema = createSelectSchema(schema.bidItems);

export const insertBidItemSchema = createInsertSchema(schema.bidItems, {
  quantity: z.string().min(1),
  lineNumber: z.number().min(1),
  bidId: z.string().uuid(),
});

export const updateBidItemSchema = insertBidItemSchema.partial().extend({
  id: z.string(),
});

const BidItemsQuerySchema = z.object({
  lineNumber: z.string().optional(),
});

export const getBidItemsQuerySchema = BidItemsQuerySchema.merge(
  z.object({
    limit: z.coerce.number().optional().default(25),
    offset: z.coerce.number().optional().default(0),
    page: z.coerce.number().optional(),
    bidId: z.string().uuid(),
    quantity: z
      .string()
      .optional()
      .transform((val) => {
        if (!val) {
          return [];
        }
        return val.split(',').map((num) => Number(num));
      })
      .default([]),
    unitPrice: z
      .string()
      .optional()
      .transform((val) => {
        if (!val) {
          return [];
        }
        return val.split(',').map((num) => Number(num));
      })
      .default([]),
    extension: z
      .string()
      .optional()
      .transform((val) => {
        if (!val) {
          return [];
        }
        return val.split(',').map((num) => Number(num));
      })
      .default([]),
    sort: z
      .string()
      .optional()
      .transform((val) => {
        if (!val) {
          return [
            {
              id: 'lineNumber',
              desc: false,
            },
          ];
        }

        try {
          const parsed = JSON.parse(val);
          const sortSchema = z.array(
            z.object({
              id: z.string(),
              desc: z.boolean(),
            }),
          );

          const result = sortSchema.safeParse(parsed);

          if (!result.success) {
            return [
              {
                id: 'lineNumber',
                desc: false,
              },
            ];
          }

          return result.data;
        } catch {
          return [
            {
              id: 'lineNumber',
              desc: false,
            },
          ];
        }
      })
      .default([]),
  }),
);

export const getBidItemsCountQuerySchema = BidItemsQuerySchema;
